<template>
  <div class="chart-radio-template">
    <label 
      v-for="option in options" 
      :key="option.value" 
      class="chart-radio-template__radio-option"
    >
      <input
        type="radio"
        :value="option.value"
        v-model="selectedOption"
        @change="updateOption"
      />
      {{ option.label }}
    </label>
  </div>
</template>

<script>
export default {
  name: "RadioButtonChartTemplate",
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedOption: null,
    };
  },
  methods: {
    updateOption() {
      this.$emit("updateOption", this.selectedOption);
    },
  },
  mounted() {
    this.selectedOption = this.options[2].value;
    this.updateOption();
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import "~@/styles/variables";

.chart-radio-template {
  display: flex;
  flex-direction: column;
  gap: rem(16);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: rem(16);
  line-height: rem(24);
  color: #333;

  &__radio-option {
    display: flex;
    align-items: center;
    gap: rem(8);
    cursor: pointer;
  }
}

input[type="radio"] {
  width: rem(20);
  height: rem(20);
  margin: 0 rem(6) 0 0;
  border: rem(2) solid #4663AB;
  accent-color: #4663AB;
  border-radius: 50%;
  outline: none;
  cursor: pointer;
}

</style>